import { Box, FormHelperText, FormLabel, Paper } from '@mui/material';
import { memo } from 'react';

import type { RichEditorControlProps } from 'types/toolbar';

const RichEditorControl = ({
  label,
  children,
  error,
}: RichEditorControlProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderColor: (theme) => theme.palette.grey[400],
        '& .ck.ck-editor__main>.ck-editor__editable.ck-focused': {
          outline:
            '1px solid var(--tw-color-blue-600, oklch(54.6% 0.245 262.881))',
        },
      }}
    >
      <FormLabel
        sx={{
          top: -12,
          left: 6,
          fontSize: 11.5,
          px: 0.75,
          bgcolor: 'background.paper',
          width: 'auto',
        }}
      >
        {label}
      </FormLabel>
      <Box
        sx={{
          mx: '-1px',
          mb: '-1px',
          mt: -3.5,
          '--ck-color-toolbar-border': 'transparent',
          '--ck-color-toolbar-background': 'transparent',
          '--ck-border-radius': '0.75rem',
          '--ck-inner-shadow': 'none',
          '--ck-focus-ring':
            '1px solid var(--tw-color-blue-600, oklch(54.6% 0.245 262.881))',
          '--ck-color-list-button-on-background':
            'var(--tw-color-blue-600, oklch(54.6% 0.245 262.881))',
          '--ck-drop-shadow': 'var(--tw-shadow-overlay-lg)',
          '& .ck.ck-content': {
            '--ck-spacing-standard': '1rem',
            fontSize: '1.15rem',
          },
          '& .ck.ck-content p': {
            fontSize: '1.15rem',
          },
        }}
      >
        {children}
      </Box>
      {error && <FormHelperText error={true}>{error}</FormHelperText>}
    </Paper>
  );
};

export default memo(RichEditorControl);
